/* Constants */
import { NodeTypes } from '@core/enums';

/* Models */
import { TreeNode } from '@core/models/tree-node.model';
import { NodeMap } from '@core/store/app/app.selectors';
import { Data, PortfolioItem } from '@core/store/portfolio/portfolio.model';

/**
 * Get children nodes of a tree node
 */
export const getChildrenNodes = (node: TreeNode): TreeNode[] => {
	let children = [];

	while (node.parent) {
		children.unshift(node);
		node = node.parent;
	}

	children = children.filter((item) => item.icon !== NodeTypes.Floor);

	return children;
};

/**
 * Get parent node of a tree node.
 */
export const getParentNode = (node: TreeNode): TreeNode => {
	if (!node.parent) {
		return null;
	}

	let currentParent = node.parent;

	while (currentParent.parent) {
		currentParent = currentParent.parent;
	}

	return currentParent;
};

/**
 * Get parent office node of a tree node.
 */
export const getParentOffice = (nodeId: number, nodeMap: NodeMap): TreeNode => {
	const currentNode = nodeMap[nodeId];

	if (!currentNode.parent) {
		return currentNode;
	}

	let currentParent = currentNode.parent;

	while (currentParent.parent && currentParent.typeId !== NodeTypes.Office) {
		currentParent = currentParent.parent;
	}

	return currentParent;
};

/**
 * Get node data of a portfolio item.
 */
export const getNodeData = (item: PortfolioItem, typeId: number): Data => {
	return item.nodeData.find((data) => data.dataType === typeId);
};

/**
 * Get occupancy data of a portfolio item.
 */
export const getOccupancyData = (item: PortfolioItem): string | number =>
{
	return item.latestData?.find(data => data.type === 'occupancy' || data.type === 'presence')?.value;
};

/**
 * Convert value based on format.
 */
export const convertValue = (value: number, format: string): number => {
	// eslint-disable-next-line no-eval
	const convertFunc = format ? eval('((value)=>' + format + ')') : (v: number) => Math.round(v);

	return convertFunc(value);
};

/**
 * Convert value to activity level.
 */
export const getActivityLevel = (value: number) =>
{
	if (value > 87.5) return 'High';
	if (value > 62.5) return 'Fairly high';
	if (value > 37.5) return 'Moderate';
	if (value > 12.5) return 'Fairly low';
	return 'Low';
};
